import {rebuildBlocks} from './helpers';
import {sigTooltipHandler} from './file_signatures';

let mutex = false;
let content;

function checkAndRebuildBlocks() {
    if (typeof (rebuildBlocks) === 'function') {
        rebuildBlocks();
    }
}

$_vikon(() => {
    content = $_vikon('body');
    rollbackSettings(content);
    setVolume(content);
    setBrailleFont(content);
    setFontSize(content);
    setImagesVisibility(content)
    setSpecialColor(content);
    setHeadset(content);
    setLetterSpacing(content);
    setInterval(content);
    $_vikon('body')
        .on('click', '.showpart-btn-list', function () {
            const thisObj = $_vikon(this);
            const container = thisObj.prev('.showpart-container-list');
            const status = thisObj.data('status');
            const headerHeight = typeof $_vikon('.table-header')[0] == "undefined" ? 0 : $_vikon('.table-header')[0].offsetHeight;
            if (status === 1) {
                container.css('max-height', 'none');
                thisObj.css('top', '0')
                    .data('status', 2)
                    .text('скрыть');
            } else {
                container.css('max-height', '50px');
                thisObj.css('top', '-16px')
                    .data('status', 1)
                    .text('показать все');
                container[0].scrollIntoView();
                window.scrollBy(0, -headerHeight);
            }
        })
        .on('click', '.showpart-btn-modal', function () {
            const thisObj = $_vikon(this);
            const modal = $_vikon('#showpart-modal');
            modal.find('.modal-title').html(thisObj.parent().find('.showpart-title-modal').html());
            modal.find('.modal-body').html(thisObj.parent().find('.showpart-container-modal').html());
            modal.find('.tooltip-sig').tooltip({
                selector: '.tooltip-sig',
                html: true,
                title: sigTooltipHandler,
                placement: 'auto',
                container: modal,
            });
            modal.modal('show');
        });
});

function rollbackSettings(content) {
    $_vikon('#rollback-special-settings').on('click', () => {
        content.removeClass('special-font-family-braille');
        sessionStorage.setItem('is-braille-on', '0');

        content.removeClass('special-img-off');
        $_vikon('#special-images-on').addClass('special-btn-active');
        $_vikon('#special-images-off').removeClass('special-btn-active');
        $_vikon('.special-img-info').addClass('hide');
        $_vikon('#abitur_slider').removeClass('hide');
        sessionStorage.setItem('is-images-on', '1');

        content.addClass('special-font-size-normal');
        content.removeClass('special-font-size-big');
        content.removeClass('special-font-size-large');
        $_vikon('#special-font-size-normal').addClass('special-btn-active');
        $_vikon('#special-font-size-big').removeClass('special-btn-active');
        $_vikon('#special-font-size-large').removeClass('special-btn-active');
        sessionStorage.setItem('special-font-size', '1');

        content.addClass('special-site-color-black-white');
        content.removeClass('special-site-color-white-black');
        content.removeClass('special-site-color-darkblue-blue');
        $_vikon('#special-site-color-black-white').addClass('special-btn-active');
        $_vikon('#special-site-color-white-black').removeClass('special-btn-active');
        $_vikon('#special-site-color-darkblue-blue').removeClass('special-btn-active');
        sessionStorage.setItem('special-site-color', '1');

        content.addClass('special-font-family-arial');
        content.removeClass('special-font-family-times-new-roman');
        $_vikon('#special-font-family-arial').addClass('special-btn-active');
        $_vikon('#special-font-family-times-new-roman').removeClass('special-btn-active');
        sessionStorage.setItem('special-font-family', '1');

        content.addClass('special-letter-spacing-normal');
        content.removeClass('special-letter-spacing-big');
        content.removeClass('special-letter-spacing-large');
        $_vikon('#special-letter-spacing-normal').addClass('special-btn-active');
        $_vikon('#special-letter-spacing-big').removeClass('special-btn-active');
        $_vikon('#special-letter-spacing-large').removeClass('special-btn-active');
        sessionStorage.setItem('special-letter-spacing', '1');

        content.removeClass('special-interval-one-and-a-half');
        content.removeClass('special-interval-double');
        content.addClass('special-interval-single');
        $_vikon('#special-interval-one-and-a-half').removeClass('special-btn-active');
        $_vikon('#special-interval-double').removeClass('special-btn-active');
        $_vikon('#special-interval-single').addClass('special-btn-active');
        sessionStorage.setItem('special-interval', '1');

        $_vikon('#special-volume-logo').addClass('fa-volume-off');
        $_vikon('#special-volume-logo').removeClass('fa-volume');
        sessionStorage.setItem('is-volume-on', '0');
        content.removeClass('special-volume-on');
        content.off('mouseup', handleVolume);
        handleVolumeTooltip();
        handleBrailleTooltip();
        checkAndRebuildBlocks();
    });
}

function setVolume(content) {
    $_vikon('#is-volume-on').on('click', () => {
        if (sessionStorage.getItem('is-volume-on') === '0') {
            $_vikon('#special-volume-logo').addClass('fa-volume');
            $_vikon('#special-volume-logo').removeClass('fa-volume-off');
            sessionStorage.setItem('is-volume-on', '1');
            content.addClass('special-volume-on');
            content.on('mouseup', handleVolume);
        } else {
            $_vikon('#special-volume-logo').addClass('fa-volume-off');
            $_vikon('#special-volume-logo').removeClass('fa-volume');
            content.removeClass('special-volume-on');
            sessionStorage.setItem('is-volume-on', '0');
            content.off('mouseup', handleVolume);
            $_vikon('body #volume_start').remove();
        }
        handleVolumeTooltip();
        checkAndRebuildBlocks();
    });
}

function setBrailleFont(content) {
    $_vikon('#is-braille-on').on('click', () => {
        if (sessionStorage.getItem('is-braille-on') === '0') {
            content.addClass('special-font-family-braille');
            content.removeClass('special-font-family-times-new-roman');
            content.removeClass('special-font-family-arial');
            $_vikon('#is-braille-on').addClass('special-btn-active');
            $_vikon('#special-font-family-times-new-roman').removeClass('special-btn-active');
            $_vikon('#special-font-family-arial').removeClass('special-btn-active');
            sessionStorage.setItem('is-braille-on', '1');
        } else {
            content.removeClass('special-font-family-braille');
            $_vikon('#is-braille-on').removeClass('special-btn-active');
            sessionStorage.setItem('is-braille-on', '0');
        }
        handleBrailleTooltip();
        checkAndRebuildBlocks();
    });
}

function setImagesVisibility(content) {
    $_vikon('#special-images-on').on('click', () => {
        content.removeClass('special-img-off');
        $_vikon('#special-images-on').addClass('special-btn-active');
        $_vikon('#special-images-off').removeClass('special-btn-active');
        $_vikon('.special-img-info').addClass('hide');
        $_vikon('#abitur_slider').removeClass('hide');
        sessionStorage.setItem('is-images-on', '1');
        checkAndRebuildBlocks();
    });
    $_vikon('#special-images-off').on('click', () => {
        content.addClass('special-img-off');
        $_vikon('#special-images-on').removeClass('special-btn-active');
        $_vikon('#special-images-off').addClass('special-btn-active');
        $_vikon('.special-img-info').removeClass('hide');
        $_vikon('#abitur_slider').addClass('hide');
        sessionStorage.setItem('is-images-on', '0');
        checkAndRebuildBlocks();
    });
}

function setFontSize(content) {
    $_vikon('#special-font-size-normal').on('click', () => {
        content.addClass('special-font-size-normal');
        content.removeClass('special-font-size-big');
        content.removeClass('special-font-size-large');
        $_vikon('#special-font-size-normal').addClass('special-btn-active');
        $_vikon('#special-font-size-big').removeClass('special-btn-active');
        $_vikon('#special-font-size-large').removeClass('special-btn-active');
        sessionStorage.setItem('special-font-size', '1');
    });
    $_vikon('#special-font-size-big').on('click', () => {
        content.removeClass('special-font-size-normal');
        content.addClass('special-font-size-big');
        content.removeClass('special-font-size-large');
        $_vikon('#special-font-size-normal').removeClass('special-btn-active');
        $_vikon('#special-font-size-big').addClass('special-btn-active');
        $_vikon('#special-font-size-large').removeClass('special-btn-active');
        sessionStorage.setItem('special-font-size', '2');
        checkAndRebuildBlocks();
    });
    $_vikon('#special-font-size-large').on('click', () => {
        content.removeClass('special-font-size-normal');
        content.removeClass('special-font-size-big');
        content.addClass('special-font-size-large');
        $_vikon('#special-font-size-normal').removeClass('special-btn-active');
        $_vikon('#special-font-size-big').removeClass('special-btn-active');
        $_vikon('#special-font-size-large').addClass('special-btn-active');
        sessionStorage.setItem('special-font-size', '3');
        checkAndRebuildBlocks();
    });
}

function setSpecialColor(content) {
    $_vikon('#special-site-color-black-white').on('click', () => {
        content.addClass('special-site-color-black-white');
        content.removeClass('special-site-color-white-black');
        content.removeClass('special-site-color-darkblue-blue');
        $_vikon('#special-site-color-black-white').addClass('special-btn-active');
        $_vikon('#special-site-color-white-black').removeClass('special-btn-active');
        $_vikon('#special-site-color-darkblue-blue').removeClass('special-btn-active');
        sessionStorage.setItem('special-site-color', '1');
        checkAndRebuildBlocks();
    });
    $_vikon('#special-site-color-white-black').on('click', () => {
        content.removeClass('special-site-color-black-white');
        content.addClass('special-site-color-white-black');
        content.removeClass('special-site-color-darkblue-blue');
        $_vikon('#special-site-color-black-white').removeClass('special-btn-active');
        $_vikon('#special-site-color-white-black').addClass('special-btn-active');
        $_vikon('#special-site-color-darkblue-blue').removeClass('special-btn-active');
        sessionStorage.setItem('special-site-color', '2');
        checkAndRebuildBlocks();
    });
    $_vikon('#special-site-color-darkblue-blue').on('click', () => {
        content.removeClass('special-site-color-black-white');
        content.removeClass('special-site-color-white-black');
        content.addClass('special-site-color-darkblue-blue');
        $_vikon('#special-site-color-black-white').removeClass('special-btn-active');
        $_vikon('#special-site-color-white-black').removeClass('special-btn-active');
        $_vikon('#special-site-color-darkblue-blue').addClass('special-btn-active');
        sessionStorage.setItem('special-site-color', '3');
        checkAndRebuildBlocks();
    });
}

function setHeadset(content) {
    $_vikon('#special-font-family-arial').on('click', () => {
        content.addClass('special-font-family-arial');
        content.removeClass('special-font-family-times-new-roman');
        $_vikon('#special-font-family-arial').addClass('special-btn-active');
        $_vikon('#special-font-family-times-new-roman').removeClass('special-btn-active');
        sessionStorage.setItem('special-font-family', '1');
        checkAndRebuildBlocks();
    });
    $_vikon('#special-font-family-times-new-roman').on('click', () => {
        content.removeClass('special-font-family-arial');
        content.addClass('special-font-family-times-new-roman');
        $_vikon('#special-font-family-arial').removeClass('special-btn-active');
        $_vikon('#special-font-family-times-new-roman').addClass('special-btn-active');
        sessionStorage.setItem('special-font-family', '2');
        checkAndRebuildBlocks();
    });
}

function setLetterSpacing(content) {
    $_vikon('#special-letter-spacing-normal').on('click', () => {
        content.addClass('special-letter-spacing-normal');
        content.removeClass('special-letter-spacing-big');
        content.removeClass('special-letter-spacing-large');
        $_vikon('#special-letter-spacing-normal').addClass('special-btn-active');
        $_vikon('#special-letter-spacing-big').removeClass('special-btn-active');
        $_vikon('#special-letter-spacing-large').removeClass('special-btn-active');
        sessionStorage.setItem('special-letter-spacing', '1');
        checkAndRebuildBlocks();
    });
    $_vikon('#special-letter-spacing-big').on('click', () => {
        content.removeClass('special-letter-spacing-normal');
        content.addClass('special-letter-spacing-big');
        content.removeClass('special-letter-spacing-large');
        $_vikon('#special-letter-spacing-normal').removeClass('special-btn-active');
        $_vikon('#special-letter-spacing-big').addClass('special-btn-active');
        $_vikon('#special-letter-spacing-large').removeClass('special-btn-active');
        sessionStorage.setItem('special-letter-spacing', '2');
        checkAndRebuildBlocks();
    });
    $_vikon('#special-letter-spacing-large').on('click', () => {
        content.removeClass('special-letter-spacing-normal');
        content.removeClass('special-letter-spacing-big');
        content.addClass('special-letter-spacing-large');
        $_vikon('#special-letter-spacing-normal').removeClass('special-btn-active');
        $_vikon('#special-letter-spacing-big').removeClass('special-btn-active');
        $_vikon('#special-letter-spacing-large').addClass('special-btn-active');
        sessionStorage.setItem('special-letter-spacing', '3');
        checkAndRebuildBlocks();
    });
}

function setInterval(content) {
    $_vikon('#special-interval-single').on('click', () => {
        content.removeClass('special-interval-one-and-a-half');
        content.removeClass('special-interval-double');
        content.addClass('special-interval-single');
        $_vikon('#special-interval-one-and-a-half').removeClass('special-btn-active');
        $_vikon('#special-interval-double').removeClass('special-btn-active');
        $_vikon('#special-interval-single').addClass('special-btn-active');
        sessionStorage.setItem('special-interval', '1');
        checkAndRebuildBlocks();
    });
    $_vikon('#special-interval-one-and-a-half').on('click', () => {
        content.removeClass('special-interval-single');
        content.removeClass('special-interval-double');
        content.addClass('special-interval-one-and-a-half');
        $_vikon('#special-interval-single').removeClass('special-btn-active');
        $_vikon('#special-interval-double').removeClass('special-btn-active');
        $_vikon('#special-interval-one-and-a-half').addClass('special-btn-active');
        sessionStorage.setItem('special-interval', '2');
        checkAndRebuildBlocks();
    });
    $_vikon('#special-interval-double').on('click', () => {
        content.removeClass('special-interval-single');
        content.removeClass('special-interval-one-and-a-half');
        content.addClass('special-interval-double');
        $_vikon('#special-interval-one-and-a-half').removeClass('special-btn-active');
        $_vikon('#special-interval-single').removeClass('special-btn-active');
        $_vikon('#special-interval-double').addClass('special-btn-active');
        sessionStorage.setItem('special-interval', '3');
        checkAndRebuildBlocks();
    });
}

function getSelection() {
    if (window.getSelection) {
        return window.getSelection();
    }
    if (document.getSelection) {
        return document.getSelection();
    }
    return null;
}

export async function handleVolume(e) {
    if ((!!e.target.id && e.target.id === 'volume_start') || mutex === true) {
        return;
    }
    $_vikon('body #volume_start').remove();
    let text = null;
    let yCord = null;
    const selection = getSelection();
    if (selection !== null && selection.rangeCount > 0) {
        const rect = selection.getRangeAt(0).getBoundingClientRect();
        text = selection.toString();
        yCord = rect.y + $_vikon('html').scrollTop();
    }

    if (!!text && !!yCord) {
        const context = new AudioContext();
        const el = $_vikon(`${'<a class="voice_btn btn btn-lg no-margin" id="volume_start" href="#" style="'
        + 'z-index:10000; position: absolute; top: '}${Math.ceil(yCord)}px; right: 15px;">Озвучить</a>`);

        if (text.length < 1300) {
            el.one('click', async (event) => {
                mutex = true;
                const vikonDomain = $_vikon('[name=vikon_domain]').val();
                try {
                    event.preventDefault();
                    el.text('Обрабатывается...')
                        .attr('style', (i, s) => {
                            return `${s || ''} text-decoration: none !important;`;
                        });

                    const response = await fetch(`${vikonDomain}/inner_api/open/sound/generate`, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify({
                            text,
                            token: window.sessionStorage ? sessionStorage.getItem('token') : null,
                        }),
                    });

                    if (response.ok) {
                        const data = await response.blob();

                        const buffer = await context.decodeAudioData(await data.arrayBuffer());
                        const source = context.createBufferSource();
                        source.buffer = buffer;
                        source.connect(context.destination);
                        source.start(0);
                        el.text('Воспроизводится...');
                        source.addEventListener('ended', () => {
                            el.remove();
                            mutex = false;
                        }, {once: true});
                    } else {
                        console.log(await response.json());
                        el.text('Не удалось озвучить выделенный текст');
                    }
                } catch (ex) {
                    mutex = false;
                    console.log(ex);
                    el.text('Не удалось озвучить выделенный текст');
                }
            });
        } else {
            el.text('Невозможно озвучить - слишком длинный выделенный текст');
        }
        $_vikon('body').append(el);
    }
}

export function handleVolumeTooltip() {
    const isVolumeOn = sessionStorage.getItem('is-volume-on') === '1';
    const tooltopMsg = isVolumeOn ? 'Выключить звук' : 'Включить звук';
    $_vikon('#is-volume-on').attr('title', tooltopMsg);
}

export function handleBrailleTooltip() {
    const isBrailleOn = sessionStorage.getItem('is-braille-on') === '1';
    const tooltopMsg = isBrailleOn ? 'Выключить шрифт Браиля' : 'Включить шрифт Браиля';
    $_vikon('#is-braille-on').attr('title', tooltopMsg);
}
